module.exports = {
  missingRequired: 'You must enter a value for required fields!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  noContacts: 'No contact found with specified search criteria.',
  contactNoAddresses: 'This contact has no addresses',
  deleteContact: 'Are you sure you want to delete this contact?',
  emptyField: 'You must enter a value for each field.',
  priceNumber: 'Price must be a number.',
  vatNumber: 'Vat must be a number.',
  selectOne: 'You must select at least one item.',
  enterOne: 'You must enter at least one search parameter.',
  outOfBusinessHours: 'Current time is not within our business hours',
  outOfYourHours: 'The time you selected is not within your business hours.',
  cantReachServer: 'Couldn\'t reach the server for calculating total. Total price might not be correct.',
  receiptSearch: 'You must select a date and receipt type or enter invoice number or receipt number.',
  noReceipts: 'No receipts found',
  noNotifications: 'There are no notifications.',
  noPayments: 'No payments found.',
  noTerminals: 'No available terminals found. Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in Standalone Mode. Finally, restart the PDQ and, if the problem persists, please contact support.',
  onlyOpenPayments: 'Only open payments can be triggered.',
  calculationFailed: 'Failed to calculate change difference. Calculating offline',
  notSameTotals: 'Payment method totals are not the same as items totals. Please check the funds.',
  contactForDelivery: 'You must select a contact for delivery.',
  checkPrinter: 'Check for default printer of user failed.',
  changeTable: 'Failed to change table usage.',
  orderNotLocked: 'Order is not locked anymore and you cannot proceed with payment.',
  tableNoOrders: 'Current table has no orders',
  failedToFetchTables: 'Failed to fetch open table orders',
  fetchTables: 'Failed to fetch tables',
  fetchTableComments: 'Failed to fetch table comments.',
  markComment: 'Failed to mark comment as read.',
  fetchCategories: 'Failed to fetch categories.',
  noCatForTables: 'There are no categories for the tables.',
  unpaidBill: 'Failed to generate unpaid bill',
  fetchPrinters: 'Failed to fetch printers',
  checkDefaultPrinter: 'Failed to check default printer',
  enterHost: 'You must enter a host.',
  enterKey: 'You must enter an api key.',
  noData: 'No data found',
  printJobs: 'Failed to fetch print jobs.',
  systemWarning: 'Triggering this function can impact your system and work negatively; only trigger if advised by support. Please confirm that you are aware of the consequences and want to proceed.',
  companySettings: 'Error getting company settings. Please log in again.',
  userRoles: 'Error getting user roles. Please log in again.',
  depUnavailable: 'Encryption unit unavailable',
  enterDate: 'You must enter both from and to date.',
  fromDate: 'From date can\'t be after to date',
  fetchPayments: 'Failed to fetch open payments',
  noReports: 'No reports available',
  exportData: 'Failed to fetch export data.',
  ticketStatus: 'Failed to check ticket status',
  ticketProcessed: 'Request is being processed: ticket#:',
  ticketData: 'Failed to fetch ticket data',
  fetchTaxReports: 'Failed to fetch tax reports',
  fetchItemUsage: 'Failed to fetch item usage reports',
  atLeastOneItemInCart: 'You must have at least one item in cart.',
  mustSelectOrderType: 'You must select the order type.',
  addContactFirst: 'You must add a contact first for this order type.',
  couldntReachServer: 'Couldn\'t reach the server for calculating total. Total price might not be correct.',
  mainwaySuccess: 'Mainaway successful',
  failedBill: 'Failed to generate unpaid bill',
  failedPrinters: 'Failed to fetch printers',
  failedDefaultPrinter: 'Failed to check default printer',
  cantEditOrder: 'This order cannot be edited.',
  failedTableComments: 'Failed to fetch table comments.',
  notLocked: 'Order is not locked anymore and you cannot proceed with editing it.',
  munutesAgo: 'minute(s) ago. Please retry later.',
  anotherUserLocked: 'Another user locked the order',
  tableState: 'Failed to change table state.',
  sizesVariants: 'Sizes or Variants are not set for this item!',
  failedCastalog: 'Failed to fetch the catalog',
  required: 'Required!',
  minNineChars: 'Minimum 9 characters!',
  galaxyAlreadyAdded: 'This Galaxy card is already added!',
  galaxyCanceled: 'Error in processing, all Galaxy Bookings canceled!',
  galaxyNotActive: 'This Galaxy card is not active, please chose another card. Status:',
  galaxyBalaceZero: 'This Galaxy card has 0 balance, please choose another card.',
  galaxyItemType: 'Error: You cannot add Galaxy card balance and regular items together.',
  cardNotFound: 'Card not found.',
  mustSelectStyle: 'You must select a style',
  mustSelectSize: 'You must select a size',
  mustSelectVariant: 'You must select a variant',
  nameMustHaveCharacters: 'Name must have at least one character.',
  selfService: 'Self-service view not found',
  walletNotActivated: 'Wallet is not activated, hence related items will be hidden',
  disabledCard: 'Disabled cards can not be used',
  contactAndWallet: 'Wallet ID and Contact can\'t be selected at the same time',
  walletNotEnabled: 'Wallet is not enabled',
  discountError: 'You can not give this discount',
  noItemReport: 'There is no item report for this time frame',
  timeOut: 'No response, please check your internet connection',
  mustBeNumber: 'Invoice number must contain only numbers.',
  requiredPassword: 'Password is required',
  passwordConditions: 'Password must be longer than 6 and shorter than 35 characters',
  matchPasswords: 'Passwords do not match',
  failedPassword: 'Failed to save password',
  invalidKey: 'Invalid activation key',
  failedCompany: 'Failed to fetch company data.',
  nameLess: 'Name must be less than 35 characters',
  requiredEmail: 'Email is required',
  notValidEmail: 'Email is not valid',
  requiredPhone: 'Phone is required',
  notValidPhone: 'Phone is not valid',
  enterData: 'Please enter your data.',
  acceptPolicy: 'You must agree with our Terms & Conditions and privacy and cookies policy',
  failedRegistration: 'Failed to register user',
  enterCredentials: 'Please enter your credentials.',
  failedLogin: 'Failed to login',
  failedContactInfo: 'Failed to fetch contact info',
  sessionExpired: 'Session expired. Please log in again.',
  phoneOrEmail: 'You must enter either phone or email',
  failToSend: 'Failed to send request',
  failedCompanyPassword: 'Password reset successfuly, failed to fetch company data.',
  failedAddress: 'Failed to update address info',
  minimalDelivery: 'Minimal total amount for delivery',
  commentShorter: 'Comment must be shorter than 1024 characters',
  invalidZip: 'Invalid Zip code',
  noPostalFound: 'No postal code found for search parameters.',
  oneItem: 'You must have at least one item in cart to calculate delivery charges',
  line1: 'You must enter Line 1',
  invalidPostal: 'The Postal code you entered is invalid.',
  postalValidate: 'Failed to validate Postal code.',
  codeOutsideArea: 'The selected post code is outside of the delivery area.',
  failedCalculate: 'Failed to calculate delivery.',
  calculateServer: 'Failed to contact the server for calculating totals. Calculated offline.',
  zipRequired: 'Zip is required',
  countryRequired: 'Country is required',
  countryUnsupported: 'Country not supported',
  totalOver: 'The total must be over',
  thisDelivery: 'for this delivery method',
  validPostal: 'You must enter a valid postal code.',
  oneItemMinimum: 'You must have at least one item in cart.',
  pageNotFound: 'Page not found',
  restaurantClosed: 'Restaurant is currently closed.',
  restaurantPreorder: 'Preorder now, restaurant is opening again at',
  restaurantSoon: 'Restaurant is closing soon. Please make your order as soon as possible.',
  restaurantReceiving: 'Restaurant is not receiving orders for today anymore.',
  paymentFailed: 'Payment failed. Redirecting to order summary...',
  malformedPayment: 'Malformed payment query. Redirecting...',
  submitFailed: 'Failed with submitting payment',
  validPostalProvide: 'You must provide a valid postal code.',
  yourSearchFor: 'Your search for',
  foundNo: 'found no results',
  bizzHours: 'Current time is not within our business hours',
  bizzHours2: 'The time you selected is not within our business hours.',
  chosenTime: 'Chosen time must be later than next',
  minutes: 'minutes',
  restaurantClosedToday: 'The Restaurant is closed today',
  choseContact: 'Please choose a contact',
  acceptAgreement: 'You must accept the agreement to submit the order',
  addAddress: 'Please add an address',
  enterPhone: 'Please enter your phone number',
  enterEmail: 'Please enter your email',
  enterLastName: 'Please enter your Last Name',
  enterPayment: 'Please select payment method',
  workingHours: 'The time you picked is outside our working hours',
  failedOrder: 'Failed to submit order',
  failedCalculate2: 'Failed to calculate delivery. Total will not be calculated',
  addressAT: 'You must enter the Address',
  validPostalOrAddress: 'Postal code or address is not valid, please change',
  requiredName: 'Name is required',
  acceptingOrders: 'We are currently not accepting orders, please try later.',
  noOrders: 'No orders found.',
};



// WEBPACK FOOTER //
// ./src/lang/en/errors.js